import _get from 'lodash/get';
import _join from 'lodash/join';
import _map from 'lodash/map';
import _split from 'lodash/split';
import _slice from 'lodash/slice';
import _isFunction from 'lodash/isFunction';

import { DASHBOARD_RESOURCES, SCOPES_MAP } from 'constant';

import { APP_TO_DASHBOARD_ACTIONS_MAP, APP_ACTIONS, KEY_NAME_MAP } from './constants';

export const actionsDependencyResolver = (pageName: string) => (props: any, dependencyValues: any) => {
	const entity = _get(dependencyValues, '0');

	if (entity) {
		return {
			options: _map(Object.entries(SCOPES_MAP[pageName][entity]), ([key, value]) => {
				let label: string = value;
				if (entity === DASHBOARD_RESOURCES.generic) {
					label = key;
				}
				return { id: value, label };
			})
		};
	}
	return [];
};

export const getSiblingDependencies = (siblingDependency: string) => (name: string) => {
	const path = _split(name, '.');
	const parentPath = _slice(path, 0, path.length - 1);

	return [_join([parentPath, siblingDependency], '.')];
};

// Will be called 2 times(in accordian and in multirowrenderer)
export const appRoleDependencyResolver = (props: any, dependencyValues: any) => {
	const action = _get(dependencyValues, '0');

	if (action) {
		const { append, arrayFields } = props;
		if (action === APP_ACTIONS.custom) {
			return { collapsibleDisabled: true };
		}

		if (_isFunction(append)) {
			const newFields = _map(arrayFields, (dashboardEntity) => {
				const modifiedDashboardEntity = { ...dashboardEntity };
				delete modifiedDashboardEntity.id;
				return {
					...modifiedDashboardEntity,
					actions: APP_TO_DASHBOARD_ACTIONS_MAP[action][modifiedDashboardEntity.entity]
				};
			});
			append(newFields);
		}
	}
	return null;
};

export const onChangeConfigValAction = (props: any) => {
	const { setValue, name } = props;
	const parentPath = _split(name, '.')[0];
	const newPath = _join([parentPath, KEY_NAME_MAP.APP_LEVEL_ACTION], '.');
	setValue(newPath, APP_ACTIONS.custom);
};
